export var encodeLengthPrefix = function (commandId, TypeRequest, wrapper) {
    var protoMessage = TypeRequest.create(wrapper);
    var protoBuffer = TypeRequest.encode(protoMessage).finish();
    var sendingBuffer = new Uint8Array(4 + protoBuffer.byteLength);
    var dv = new DataView(sendingBuffer.buffer);
    dv.setInt32(0, commandId);
    sendingBuffer.set(protoBuffer, 4);
    return sendingBuffer;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/encoder/encodeLengthPrefix.ts
// module id = 2989
// module chunks = 3